import { render, staticRenderFns } from "./DetailGroup.vue?vue&type=template&id=0cf1ffe3&"
import script from "./DetailGroup.vue?vue&type=script&lang=js&"
export * from "./DetailGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports